import { ReactComponent as AddIcon } from '../../components/icons/add-icon.svg';
import { ReactComponent as Trash } from '../../components/icons/trash.svg';
import { ReactComponent as TwoPeople } from '../../components/icons/two-people.svg';
import { ReactComponent as UserOctagon } from '../../components/icons/user-octagon.svg';
import { ReactComponent as SearchIcon } from '../../components/icons/search.svg';
import SortArrows from '../../components/icons/sort-arrows.jsx';
import CustomButton from '../../components/components/custom_button/customButton';
import CustomInput from '../../components/components/custom_input/customInput';
import {setKeyword, setSearchValue} from "../../store/userTabSlice";

// Akcje dla tabeli użytkowników
export const userActions = {
  deleteSelected: (selectedIds) => {
    console.log('Usuń zaznaczone użytkowników:', selectedIds);
    alert('W trakcie implementacji!')
    // Logika usuwania użytkowników na podstawie zaznaczonych ID
  },
  changeTab: (tabName, dispatch, setActiveUsersTab) => {
    console.log('Zmieniono zakładkę na:', tabName);
    dispatch(setActiveUsersTab(tabName));
  },
};

// Konfiguracja nagłówków tabeli
export const getHeaders = (sortBy, sortDirection, dispatch, setSorting, sortArrowColorActive, sortArrowColorInactive, rowsUsers, checkedItems) => [
  <input
  type="checkbox"
  checked={rowsUsers.every((row) => checkedItems.includes(row[1]))} // Sprawdzenie, czy wszystkie elementy są zaznaczone
  onChange={(e) => {
    const allIds = rowsUsers.map((row) => row[1]); // Pobierz ID wszystkich elementów
    if (e.target.checked) {
      // Dodaj wszystkie elementy do checkedItems
      dispatch({ type: 'users/setCheckedItems', payload: [...new Set([...checkedItems, ...allIds])] });
    } else {
      // Usuń wszystkie elementy z checkedItems
      dispatch({ type: 'users/setCheckedItems', payload: checkedItems.filter((id) => !allIds.includes(id)) });
    }
  }}
/>,
  'ID',
    <div className="table-columns-headers">
        <div>Email</div>
        <SortArrows
            upColor={sortBy === 'email' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
            downColor={sortBy === 'email' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
            className="menu-icon"
            onClick={() => {
                if (sortBy !== 'email') {
                    dispatch(setSorting({ sortBy: 'email', sortDirection: 'ASC' }));
                } else {
                    if (sortDirection === 'ASC') {
                        dispatch(setSorting({ sortBy: 'email', sortDirection: 'DESC' }));
                    } else {
                        dispatch(setSorting({ sortBy: null, sortDirection: null }));
                    }
                }
            }}
        />
    </div>,

    <div className="table-columns-headers">
        <div>Rejestracja</div>
        <SortArrows
            upColor={sortBy === 'createdAt' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
            downColor={sortBy === 'createdAt' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
            className="menu-icon"
            onClick={() => {
                if (sortBy !== 'createdAt') {
                    dispatch(setSorting({ sortBy: 'createdAt', sortDirection: 'ASC' }));
                } else {
                    if (sortDirection === 'ASC') {
                        dispatch(setSorting({ sortBy: 'createdAt', sortDirection: 'DESC' }));
                    } else {
                        dispatch(setSorting({ sortBy: null, sortDirection: null }));
                    }
                }
            }}
        />
    </div>,

    <div className="table-columns-headers">
    <div>Imie i Nazwisko </div>
    <SortArrows
      upColor={sortBy === 'name' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'name' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'name') {
          dispatch(setSorting({ sortBy: 'name', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'name', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
  <div className="table-columns-headers">
    <div>Uprawnienia</div>
    <SortArrows
      upColor={sortBy === 'role' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'role' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'role') {
          dispatch(setSorting({ sortBy: 'role', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'role', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,

    <div className="table-columns-headers">
        <div>Zdjecie Profilowe</div>
        <SortArrows
            upColor={sortBy === 'has_photo' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
            downColor={sortBy === 'has_photo' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
            className="menu-icon"
            onClick={() => {
                if (sortBy !== 'has_photo') {
                    dispatch(setSorting({ sortBy: 'has_photo', sortDirection: 'ASC' }));
                } else {
                    if (sortDirection === 'ASC') {
                        dispatch(setSorting({ sortBy: 'has_photo', sortDirection: 'DESC' }));
                    } else {
                        dispatch(setSorting({ sortBy: null, sortDirection: null }));
                    }
                }
            }}
        />
    </div>,

  <div className="table-columns-headers">
    <div>Abonament</div>
    <SortArrows
      upColor={sortBy === 'accountPlan' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'accountPlan' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'accountPlan') {
          dispatch(setSorting({ sortBy: 'accountPlan', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'accountPlan', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
  <div className="table-columns-headers">
  <div>Akcje</div>
</div>,
];

// Szerokości kolumn
export const headerWidths = [
    '42px',                     // checkbox
    '50px',                     // (optional) static icon col
    'minmax(260px, 3fr)',       // Email
    'minmax(140px, 2fr)',       // Rejestracja
    'minmax(200px, 2fr)',       // Imię i Nazwisko
    'minmax(140px, 2fr)',       // Uprawnienia
    'minmax(160px, 2fr)',       // Zdjęcie Profilowe
    'minmax(180px, 1.4fr)',     // Abonament
    'minmax(110px, 1fr)',       // Akcje
];
// Konfiguracja zakładek
export const tabsConfig = (activeUsersTab, dispatch, setActiveUsersTab) => [
  {
    icon: TwoPeople,
    name: 'Użytkownicy',
    hoverClass: 'hover-effect',
    activeClass: activeUsersTab === 'Użytkownicy' ? 'is-active' : '',
    onClick: () => userActions.changeTab('Użytkownicy', dispatch, setActiveUsersTab),
    toggleActive: true,
  },
  {
    icon: UserOctagon,
    name: 'Administratorzy',
    hoverClass: 'hover-effect',
    activeClass: activeUsersTab === 'Administratorzy' ? 'is-active' : '',
    onClick: () => userActions.changeTab('Administratorzy', dispatch, setActiveUsersTab),
    toggleActive: true,
  },
];

// Konfiguracja przycisków
export const buttonsConfig = (toggleAddModal) =>[
  {
    icon: AddIcon,
    name: 'Dodaj użytkownika',
    baseClass: 'custom-button-black',
    hoverClass: 'hover-effect',
    activeClass: '',
    onClick: () => {
      toggleAddModal();
    },
    toggleActive: false,
  },
];

export const empty = [];

// Konfiguracja lewej strony
export const leftSideConfig = [
  {
    component: CustomButton,
    props: {
      icon: Trash,
      name: 'Usuń zaznaczone',
      baseClass: 'custom-button-white',
      hoverClass: 'hover-effect',
      activeClass: '',
      borders: 'LRBT',
      onClick: () => userActions.deleteSelected([]), // Przekaż tutaj zaznaczone ID użytkowników
      toggleActive: false,
    },
  },
];

// Konfiguracja prawej strony
export const rightSideConfig = (searchValue, dispatch) => [
  {
    component: CustomInput,
    props: {
      icon: SearchIcon,
      placeholder: 'Wyszukaj',
      hoverClass: 'hover-effect',
      borders: 'LRBT',
      bordersClassPrefix: 'border-black-',
      baseClass: 'custom-input',
      activeClass: '',
      value: searchValue,
      onChange: (e) => {
        e.preventDefault();
        let value = e.target.value;
        dispatch(setSearchValue(value)); // Ustaw wartość wyszukiwania w stanie lokalnym
        if (value.length >= 3 ) {
          dispatch(setKeyword(value)); // Aktualizuj stan w Reduxie
        } else {
          dispatch(setKeyword(null)); // Resetuj stan w Reduxie, jeśli mniej niż 3 znaki
        }
      }
      }
  },
];